import '../styles/main.scss';
import { elements } from './base';
import { elementsStrings } from './base';

import objectFitPolyfill from 'objectFitPolyfill';



// import arrowRight from '../assets/images/arrow_right.png';
// import backArea from '../assets/images/back_img.jpg';
// import book from '../assets/images/book.png';
// import border from '../assets/images/border.png';
// import btnClaim from '../assets/images/btn_claim.png';
// import btnExpand from '../assets/images/btn_expand.png';
// import btnGet from '../assets/images/btn_get.png';
// import card from '../assets/images/card.png';
// import faraonLeft from '../assets/images/faraon_left.png';
// import faraonRight from '../assets/images/faraon_right.png';
// import gameLogo from '../assets/images/game_logo.png';
// import logoLV from '../assets/images/logo.png';
// import openBook from '../assets/images/open_book.png';
// import papyrus1 from '../assets/images/papyrus.png';
// import gamePrev1 from '../assets/images/preview_game1.png';
// import gamePrev2 from '../assets/images/preview_game2.png';
// import gamePrev3 from '../assets/images/preview_game3.png';
// import spin1 from '../assets/images/spin_basic.png';
// import spin2 from '../assets/images/spin_standard.png';
// import spin3 from '../assets/images/spin_premium.png';
// import spin4 from '../assets/images/spin_mega.png';
// import temsBack from '../assets/images/terms_back-img2.jpg';
// import termsBorder from '../assets/images/terms_border.png';
// import termsShadow from '../assets/images/terms_shadow.png';





const { hamburger,
    backdrop,
    nav,
    header,
    logo,
    btn,
    btnBox,
    shadow,
    termsBackdrop,
    termsLastItem,
    stars,
    papyrus } = elements;



const { hamburgerActive,
    backdropActive,
    navMobile,
    navHide,
    backdropTermsActive,
    showTermsItem,
    shadowHidden,
    papyrusOpen } = elementsStrings;




btn.addEventListener('click', (e)=>{
    e.preventDefault()
    termsBackdrop.classList.toggle(backdropTermsActive);
    termsLastItem.classList.toggle(showTermsItem);
    shadow.classList.toggle(shadowHidden);
    papyrus.classList.toggle(papyrusOpen);


});



hamburger.addEventListener('click', ()=> {
    hamburger.classList.toggle(hamburgerActive);
    backdrop.classList.toggle(backdropActive);
    header.classList.toggle(navMobile);
    nav.classList.toggle(navHide);

});